import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDatepickerIntl, MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ExternalLinkDirectiveModule } from '@commons/directives/external-link/external-link.directive';
import { DatepickerAriaIntl } from '@commons/intl/intl.service';
import { WzbCarouselModule } from '@shared/wizbii-carousel/carousel.component';
import { ImaginarySrcModule } from '@wizbii/angular-utilities';
import { QuicklinkModule } from 'ngx-quicklink';

@NgModule({
  imports: [
    CommonModule,
    QuicklinkModule,
    RouterModule,
    MatIconModule,
    WzbCarouselModule,
    MatDatepickerModule,
    ExternalLinkDirectiveModule,
    ImaginarySrcModule,
  ],
  exports: [
    QuicklinkModule,
    CommonModule,
    RouterModule,
    MatIconModule,
    WzbCarouselModule,
    MatDatepickerModule,
    ExternalLinkDirectiveModule,
    ImaginarySrcModule,
  ],
  providers: [{ provide: MatDatepickerIntl, useClass: DatepickerAriaIntl }],
})
export class SharedModule {}
